import { render } from "./TeramsAndCondition.vue?vue&type=template&id=15eac2ce"
import script from "../js/terms-and-condition.js?vue&type=script&lang=js&external"
export * from "../js/terms-and-condition.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__